import React, { useEffect, useRef, useState } from 'react';

function TruckScroller() {
  const containerRef = useRef(null);
  const truckRef = useRef(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const trackTop = 60;
    const trackBottom = 60;
    const truckH = 50;

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const percent = docHeight > 0 ? Math.min(scrollTop / docHeight, 1) : 0;

      if (containerRef.current) {
        containerRef.current.style.opacity = scrollTop > 50 ? '1' : '0';
      }

      const trackHeight = window.innerHeight - trackTop - trackBottom - truckH;
      const truckTop = trackTop + percent * trackHeight;

      if (truckRef.current) {
        truckRef.current.style.top = truckTop + 'px';
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (isMobileView) return null;

  return (
    <div ref={containerRef} style={{
      position: 'fixed',
      right: 6,
      top: 0,
      bottom: 0,
      width: 40,
      zIndex: 9998,
      pointerEvents: 'none',
      opacity: 0,
      transition: 'opacity 0.4s ease',
    }}>
      {/* Road track — thin line */}
      <div style={{
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        top: 60,
        bottom: 60,
        width: 2,
        background: 'rgba(255,255,255,0.08)',
        borderRadius: 1,
      }}>
        <div style={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: 2,
          backgroundImage: 'repeating-linear-gradient(to bottom, rgba(255,255,255,0.2) 0px, rgba(255,255,255,0.2) 8px, transparent 8px, transparent 20px)',
        }} />
      </div>

      {/* Truck — small minimalist icon */}
      <div ref={truckRef} style={{
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        top: 60,
        width: 24,
        height: 50,
        willChange: 'top',
      }}>
        <svg viewBox="0 0 24 50" width={24} height={50} fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Cargo body */}
          <rect x="3" y="1" width="18" height="26" rx="2" fill="#4dc247" stroke="#4dc247" strokeWidth="0.5"/>
          {/* Cabin */}
          <rect x="5" y="30" width="14" height="12" rx="2" fill="#3ba83f" stroke="#4dc247" strokeWidth="0.5"/>
          {/* Windshield */}
          <rect x="7" y="32" width="10" height="3" rx="1" fill="rgba(255,255,255,0.25)"/>
          {/* Connection */}
          <rect x="10" y="27" width="4" height="3" fill="#3ba83f"/>
          {/* Wheels */}
          <circle cx="7" cy="44" r="2.2" fill="#222"/>
          <circle cx="7" cy="44" r="1" fill="#444"/>
          <circle cx="17" cy="44" r="2.2" fill="#222"/>
          <circle cx="17" cy="44" r="1" fill="#444"/>
          {/* Headlights */}
          <circle cx="8" cy="41" r="0.8" fill="rgba(255,255,200,0.7)"/>
          <circle cx="16" cy="41" r="0.8" fill="rgba(255,255,200,0.7)"/>
        </svg>
      </div>
    </div>
  );
}

export default TruckScroller;
